export const isOrderedListBlock = (node) => node.tagName === "ol";
export const isUnorderedListBlock = (node) => node.tagName === "ul";
export const isListBlock = (node) => isUnorderedListBlock(node) || isOrderedListBlock(node);
export const isListItem = (node) => node.tagName === "li";
export const isExternalLink = (node) => isAnchor(node) && !node.attributes["data-item-id"];
export const isAnchor = (node) => node.tagName === "a";
/**
 * Returns `true` for text nodes and type guards the node as `DomTextNode`.
 */
export const isText = (node) => node.type === "text";
/**
 * Returns `true` for HTML nodes and type guards the node as `DomHtmlNode`.
 */
export const isElement = (node) => node.type === "tag";
/**
 * Returns `true` if the node is a linked item node (`<object></object>`) and narrows type guard.
 */
export const isLinkedItem = (node) => isElement(node)
    && node.tagName === "object"
    && node.attributes["type"] === "application/kenticocloud";
/**
 * Returns `true` if the node is a rich text image node (`<figure></figure>`) and narrows type guard.
 */
export const isImage = (node) => isElement(node)
    && node.tagName === "figure"
    && node.attributes["data-asset-id"] !== undefined;
/**
 * Returns `true` if the node is a link to a content item and narrows type guard.
 */
export const isItemLink = (node) => isAnchor(node) && node.attributes["data-item-id"] !== undefined;
/**
 * Returns `true` if the node is a Kontent.ai rich text `img` node and narrows type guard.
 */
export const isNestedImg = (node) => node !== undefined
    && isElement(node)
    && node.tagName === "img"
    && node.attributes["data-asset-id"] !== undefined;
/**
 * Recursively counts the number of text nodes and line breaks within a given DOM node and all of its descendants.
 *
 * @param node - Node to start counting from
 * @returns The total number of text nodes found within the provided node and its children
 */
export const countChildTextNodesAndLineBreaks = (node) => node.type === "text" || node.tagName === "br"
    ? 1
    : node.children.reduce((count, child) => count + countChildTextNodesAndLineBreaks(child), 0);
export const throwError = (msg) => {
    throw new Error(msg);
};
